import { Link } from "react-router-dom";
import { useState } from "react";
import { categories } from "@/mocks/comics";

const NEWSLETTER_FORM_URL = "https://readdy.ai/api/form/d9pc48qftmtnfcfh0kc0";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem("website_alt") as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    if (!email.trim()) return;
    setLoading(true);
    setError("");

    try {
      const url = NEWSLETTER_FORM_URL;
      const formData = new FormData(form);
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === "OK") {
        setSubmitted(true);
        setEmail("");
      } else {
        const msg = parsed?.meta?.message || parsed?.message || responseText || "提交失败，请稍后再试";
        setError(msg);
      }
    } catch {
      setError("网络错误，请检查连接后重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50">
              韩漫之家
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              韩漫之家是专业的韩国漫画在线阅读平台，提供好看韩国漫画、韩漫在线免费阅读与高清韩漫大全，致力于为漫画爱好者提供稳定优质的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link></li>
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">订阅更新</h4>
            <p className="text-sm text-background-400 mb-4">获取最新韩漫更新通知和阅读推荐</p>
            {submitted ? (
              <p className="text-sm text-accent-400 font-medium">感谢订阅！我们会及时为您推送最新内容。</p>
            ) : (
              <form onSubmit={handleNewsletterSubmit} data-readdy-form className="flex flex-col gap-2">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱"
                    required
                    className="flex-1 px-4 py-2.5 text-sm rounded-lg bg-background-800 text-background-100 placeholder:text-background-500 border border-background-700 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                  >
                    {loading ? "提交中..." : "订阅"}
                  </button>
                </div>
                {error && <p className="text-xs text-red-400">{error}</p>}
              </form>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫之家. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}